import { APP_INITIALIZER } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { catchAndMapTo } from 'src/app/shared/rx.helpers';
import { WhiteLabelService } from './white-label.service';
import { filter, first, mergeMap } from 'rxjs/operators';

export const whiteLabelInitProvider = {
  provide: APP_INITIALIZER,
  deps: [AuthService, WhiteLabelService],
  multi: true,
  useFactory: (authService: AuthService, whiteLabelService: WhiteLabelService) => () => {
    return authService.isReady$
      .pipe(
        filter(Boolean),
        mergeMap(() => whiteLabelService.initWhiteLabelInfo()),
        catchAndMapTo(null),
        first(),
      )
      .toPromise();
  },
};
